export default "__VITE_ASSET__DwwldRaW__"